import { render, staticRenderFns } from "./lawsuit-follow-arbitrate.vue?vue&type=template&id=6db4da42&scoped=true"
import script from "./lawsuit-follow-arbitrate.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-arbitrate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4da42",
  null
  
)

export default component.exports